import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import CancellationReason from 'components/account/Order/CancellationReason';
import OrderProduct from 'components/account/Order/OrderProduct';
import css from 'styles/components/account/cancelOrderTableLayout.scss';
import {
  cancelled as cssCancelled,
  itemPrice as cssItemPrice,
  itemStatus as cssItemStatus,
  orderTable as cssOrderTable,
  price as cssPrice,
  statusLabel as cssStatusLabel
} from 'styles/components/account/orderTableLayout.scss';

const CancelOrderTableLayout = ({ lineItems, cancellationReasons, onCancellationReasonChange, isCancellationConfirmed }) => (
  <table className={cssOrderTable}>
    <thead>
      <tr>
        <th>Items</th>
        <th>Status</th>
        <th className={cssPrice}>Price</th>
      </tr>
    </thead>
    <tbody>
      {lineItems.map((lineItem, index) => {
        const { amount, product } = lineItem;
        return (
          <tr key={index}>
            <td>
              <OrderProduct product={product}/>
            </td>
            <td>
              {
                isCancellationConfirmed
                  ? <div className={cssItemStatus}><span className={cn(cssStatusLabel, cssCancelled)}>Cancelled</span></div>
                  : <div className={css.cancellationReason}>
                    <CancellationReason
                      index={index}
                      lineItem={lineItem}
                      cancellationReasons={cancellationReasons}
                      onCancellationReasonChange={onCancellationReasonChange}/>
                  </div>
              }
            </td>
            <td>
              <div className={cssItemPrice}>
                {amount}
              </div>
            </td>
          </tr>
        );
      })}
    </tbody>
  </table>
);

CancelOrderTableLayout.contextTypes = {
  testId: PropTypes.func
};

CancelOrderTableLayout.propTypes = {
  lineItems: PropTypes.array.isRequired,
  cancellationReasons: PropTypes.array.isRequired,
  isCancellationConfirmed: PropTypes.bool,
  onCancellationReasonChange: PropTypes.func.isRequired
};

export default CancelOrderTableLayout;
